<div class="app-loader-backdrop fadeIn" *ngIf="showLoader">
  <div class="app-loader">
    <!-- <svg height="110" width="110">
      <circle cx="55" cy="55" r="50" />
    </svg> -->
    <div *ngIf="copyLoaded && onlyCaptions">
      <h4 class="flyBack">{{appCopy.panelHeader['creatingBooking'+selectedLanguage] }}</h4>
    </div>

    <img src="../images/loader-image.gif" width="180" alt="portr logo">
    <b *ngIf="showLoaderMessage && copyLoaded">{{appCopy.panelHeader['showMessage'+selectedLanguage] }}</b>
    <ng-template *ngIf="onlyLoader else default">
    </ng-template>

    <ng-template #default>
      <div *ngIf="copyLoaded">
        <div *ngIf="!onlyCaptions">
          <h4>{{ customCopy === '' ? '' : appCopy.panelHeader['titlePayment'+selectedLanguage] }}</h4>
          <p *ngIf="customCopy !== ''" class="text-caption">{{ customCopy }}</p>
        </div>
        <app-trust-pilot></app-trust-pilot>
      </div>
    </ng-template>
  </div>
</div>
